import { Box, Typography } from "@mui/material";
import useColors from "../../../api/hooks/useColors";
import CodeBlockWithCopy from "./CodeBlockWithCopy";
import OnPremCollapseSection from "./OnPremCollapseSection";

export default function DebugUtilsSection() {
  const colors = useColors();

  return (
    <OnPremCollapseSection
      title="Debug Utils"
      defaultCollapsed={true}
      borderBottom={false}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pl: 4 }}>
        <Typography variant="body1" sx={{ color: colors.text_secondary }}>
          Use these utilities for troubleshooting and verifying your network
          setup.
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body2" sx={{ color: colors.text_secondary }}>
            List the Breeze connector pods in the cluster
          </Typography>
          <CodeBlockWithCopy
            code="oc get pods -l app.kubernetes.io/instance=breeze-connector"
            eventName="User copied debug utils command"
          />
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body2" sx={{ color: colors.text_secondary }}>
            Show detailed information for the pod
          </Typography>
          <CodeBlockWithCopy
            code={"oc describe pod <pod-name>"}
            eventName="User copied debug utils command"
          />
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body2" sx={{ color: colors.text_secondary }}>
            Stream logs from the pod
          </Typography>
          <CodeBlockWithCopy
            code={"oc logs -f <pod-name>"}
            eventName="User copied debug utils command"
          />
        </Box>
      </Box>
    </OnPremCollapseSection>
  );
}
